
export * from '../../frontend-data-set-web/__liferay__/index.js';
